import { render } from "./DeleteAdministratorDialog.vue?vue&type=template&id=304da052"
import script from "./DeleteAdministratorDialog.vue?vue&type=script&lang=js"
export * from "./DeleteAdministratorDialog.vue?vue&type=script&lang=js"

import exportComponent from "C:\\stuff\\dfob\\adminui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__